import { render } from "./leaves-admin-modal.vue?vue&type=template&id=c3b56314&scoped=true"
import script from "./leaves-admin-modal.vue?vue&type=script&lang=js"
export * from "./leaves-admin-modal.vue?vue&type=script&lang=js"

import "./leaves-admin-modal.vue?vue&type=style&index=0&id=c3b56314&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3b56314"]])

export default __exports__